<div class="expansions-wrap w-100">
    <div class="desc" i18n>Search and select the participants</div>
    <div
        class="users-wrap"
        fxLayout="column"
        fxLayoutAlign="center start"
        fxLayoutGap="5px"
        [formGroup]="participantUsersForm"
    >
        <div fxLayout="row" fxLayoutGap="20px" class="w-100" fxLayoutGap.lt-md="10px">
            <mat-form-field class="small-field users-rec-input default-select-user w-100" appearance="fill">
                <input
                    type="text"
                    matInput
                    #userRecieverInput
                    i18n-placeholder
                    placeholder="Search"
                    [formControl]="userCtrl"
                    [matAutocomplete]="autoUser"
                />
                <mat-autocomplete
                    #autoUser="matAutocomplete"
                    (optionSelected)="selectedUsersWithSelect(autoUser, $event.option.value)"
                >
                    <mat-option *ngFor="let user of userSearch$ | async" [value]="user">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon> {{ user.role_value | userRoleIcon }}</mat-icon>
                            <span>{{ user.name }}</span>
                        </div>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <!-- <span class="check-egk-exam" i18n
            >Check {{ AppScope.USERS | modelDynamicLabel | async }} who have passed the EGK exam</span
        > -->
        <div formArrayName="participantUsersArray" fxLayout="column" fxLayoutAlign="start start">
            <div
                *ngFor="let userSelect of participantUsersArray.controls; let odd = odd; let even = even"
                [formGroup]="userSelect | cast"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="10px"
            >
                <mat-checkbox
                    matTooltip="Mark the checkbox of those who have been approved"
                    i18n-matTooltip
                    formControlName="value"
                ></mat-checkbox>
                <mat-chip
                    (removed)="removeUserSelect(userSelect.value.id)"
                    [selectable]="false"
                    class="users-wrap"
                    [ngClass]="{
                        'dark-blue-bg': getResUserById(userSelect.value.id).role_value === 'user',
                        'green-bg': getResUserById(userSelect.value.id).role_value !== 'user'
                    }"
                >
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <mat-icon>{{ getResUserById(userSelect.value.id).role_value | userRoleIcon }}</mat-icon>
                        <span>{{ getResUserById(userSelect.value.id).fname }}</span>
                        <span> {{ getResUserById(userSelect.value.id).lname }}</span>
                    </div>
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </div>
        </div>
    </div>
</div>
